module.exports = __webpack_public_path__ + "static/media/Map-Alm.26b9d2a9.PNG";